var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.79175,
    cy: 8.29102,
    r: 6.375,
    stroke: "#8E93A6",
    strokeOpacity: 0.4,
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4501 15.3578C15.4057 15.4249 15.3254 15.5051 15.1649 15.6656C15.0044 15.8262 14.9241 15.9064 14.8571 15.9508C14.4642 16.211 13.9328 16.0769 13.7104 15.6615C13.6724 15.5906 13.6398 15.4819 13.5747 15.2644C13.5035 15.0268 13.4679 14.908 13.461 14.8244C13.4205 14.3322 13.8314 13.9212 14.3237 13.9617C14.4073 13.9686 14.5261 14.0042 14.7637 14.0754C14.9812 14.1406 15.0899 14.1731 15.1608 14.2111C15.5762 14.4335 15.7102 14.965 15.4501 15.3578Z",
    stroke: "#1C274C",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.ba21c0149b62c45292ea83a43e027787.svg";
export { ForwardRef as ReactComponent };